import { get } from 'lodash';

import { fetch } from '@utils/utils';
import * as T from '@modules/employees/_employeesTypes';

// structure of entity after it is created with empty data
export const defaultEmployee = {
  id: 'b9c333d5-fa60-4a53-8620-82ef3c84e84c',
  created: '2018-04-16T07:35:26.717Z',
  updated: '2018-04-16T07:35:26.720Z',
  files: [],
  contracts: [],
  certificates: [],
  trainings: [],
  identifications: [],
  fullName: '',
  label: 'null - '
};

export const getAllEmployees = async (): Promise<T.Employee[]> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/employees/`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Employee[] = await response.json();

    return json;
  } catch (err) {
    return [];
  }
};

export const getEmployee = ({ addError }) => async (id: string): Promise<T.Employee> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/employees/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Employee = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return defaultEmployee;
  }
};

export const putEmployee = ({ addError, addSuccess }) => async (
  formData: T.Employee,
  errorMessage: string
): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/employees/${get(formData, 'id')}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(formData)
    });

    const result = await response.json();
    addSuccess();
    return result;
  } catch (err) {
    addError(errorMessage ? errorMessage : err);
    return null;
  }
};

export const setPassword = ({ addError, addSuccess }) => async (
  id: string,
  credentials: T.EmployeeCredentials
): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/employees/${id}/edit-credentials`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(credentials)
    });
    addSuccess('Přihlasovací údaje byly úspěšně změneny.');
    return response;
  } catch (err) {
    addError('Změna přihlasovacích údajú se nepovedla.');
    return null;
  }
};

export const changePassword = ({ addError, addSuccess }) => async (payload: any): Promise<any> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/employees/change-password`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ password: payload.password, passwordAgain: payload.passwordConfirm })
    });
    addSuccess('Heslo bylo úspěšně změneno.');
    return response;
  } catch (err) {
    console.log(err);
    addError('Změna hesla se nepovedla.');
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/modules/employees/_employeesActions.ts